// extracted by mini-css-extract-plugin
export var container = "ErrorBoundary-module--container--80038";